import * as colors from '../../styles/colors';

export const defaultTheme = {
  bannerBackground: colors.blueGrey20,
  bannerTextColor: colors.darkGrey,
};
